import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { getUserText } from 'ziphy-web-shared/basic/helpers';
import { Button, CustomLink } from 'ziphy-web-shared/basic/lib/buttons';
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Badge, PatientInfoBox, UserPhoto } from 'ziphy-web-shared/basic/lib/simple';
import { $modal } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { customActions } from '@config/customActions';
import mainConfig from '@config/main';
import AddPatientModal from '../addPatientModal/AddPatient.modal';
import styles from './PatientsList.module.scss';
const PatientsList = ({ items, to, onClick, addBtnText, addOnDone, withSearch, isModal, }) => {
    const { t } = useTranslation();
    addBtnText = addBtnText || t('btn.add_patient');
    const [searchString, setSearchString] = useState('');
    const preparedList = useMemo(() => {
        let result = items;
        if (searchString === null || searchString === void 0 ? void 0 : searchString.trim()) {
            let needle = searchString.toLowerCase().split(' ');
            result = result.filter((x) => {
                let full = [x.firstName, x.lastName].join(' ').toLowerCase();
                return needle.every((n) => full.includes(n));
            });
        }
        return _.sortBy(result, (x) => {
            return [x.firstName, x.lastName].join(' ').toLowerCase();
        });
    }, [items, searchString]);
    function handleOnTo(item) {
        if (typeof to === 'function') {
            return to(item);
        }
    }
    function handleOnClick(item) {
        if (isModal && item.isDeceased) {
            return;
        }
        if (typeof onClick === 'function') {
            onClick(item);
        }
    }
    function handleAddPatient() {
        let params = {};
        if (typeof addOnDone === 'function') {
            params.onDone = addOnDone;
        }
        $modal.add(AddPatientModal, {
            onDone: typeof addOnDone === 'function' ? addOnDone : null,
            hasContacts: true,
        });
    }
    return (_jsxs(_Fragment, { children: [(withSearch || items.length > mainConfig.searchIfMore) && (_jsx(Input, { className: "mb-20", field: { value: searchString, onChange: setSearchString }, placeholder: t('select_patient.ph.search'), mode: ['md', 'secondary'], leftElement: 'search', clear: true, clearedValue: '' })), _jsxs("div", Object.assign({ className: classNames(styles.patientsList, isModal && styles.isModal) }, { children: [customActions.HANDLE_ADD_PATIENT && isModal && (_jsx(Button, Object.assign({ autoTarget: customActions.HANDLE_ADD_PATIENT({ callback: handleAddPatient }), mode: ['secondary-dark', 'block', 'sm'], leftElement: 'plus', className: 'mt-10 mb-20' }, { children: addBtnText }))), preparedList.map((item) => (_jsx(CustomLink, Object.assign({ autoTarget: handleOnTo(item), className: styles.patientsListItem, onClick: () => handleOnClick(item) }, { children: _jsx(PatientInfoBox, { value: item.isDeceased ? (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: styles.deceasedValue }, { children: [getUserText(item, ['fullName']), ' ', item.isDefault && _jsxs("span", { children: ["(", t('user.you'), ")"] })] })), _jsx(Badge, Object.assign({ className: "ml-1", mode: [isModal ? 'gray' : 'white-gray', 'sm', 'rounded'] }, { children: t('label.deceased') }))] })) : (_jsxs(_Fragment, { children: [getUserText(item, ['fullName']), ' ', item.isDefault && _jsxs("span", Object.assign({ className: "text-muted" }, { children: ["(", t('user.you'), ")"] }))] })), label: getUserText(item, ['gender', 'yo']), mode: isModal && ['transparent'], className: isModal && 'p-0', leftElement: _jsx(UserPhoto, { item: item, mode: item.isDeceased ? 'gray' : undefined }), clickable: true }) }), item.id))), customActions.HANDLE_ADD_PATIENT && !isModal && (_jsx(Button, Object.assign({ autoTarget: customActions.HANDLE_ADD_PATIENT({ callback: handleAddPatient }), mode: ['secondary-dark', 'block', 'md'], leftElement: 'plus', className: 'mt-10' }, { children: addBtnText })))] }))] }));
};
export default observer(PatientsList);
